const {
  ensureIterable
} = require('../../internal/iterable.js');

function __size(iterable) {
  const iter = ensureIterable(iterable);
  let size = 0;

  for (const _ of iter) {
    size++;
  }

  return size;
}

exports.__size = __size;
const size = __size;
exports.size = size;